import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth/auth.service";
import {Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PasswordRecoveryModal} from "../../../modals/password-recovery-modal/password-recovery-modal.component";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private modalService: NgbModal,
  ) {
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.auth.login(this.loginForm.controls.email.value, this.loginForm.controls.password.value)
      .subscribe(
        () => this.router.navigate(['/']),
        error => alert(error.error.error))
    ;
  }

  onRequestPasswordRecovery() {
    const modalRef = this.modalService.open(PasswordRecoveryModal, {size: 'lg'});
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email],],
      password: ['', Validators.required] // todo: char requirements
      // email: ['giacomo.t@luckyseven.it', [Validators.required, Validators.email], ],
      // password: ['giacomo.t', Validators.required] // todo: char requirements
    })
  }
}
